import { render, staticRenderFns } from "./relationship.vue?vue&type=template&id=15cf22b5&scoped=true"
import script from "./relationship.vue?vue&type=script&lang=js"
export * from "./relationship.vue?vue&type=script&lang=js"
import style0 from "./relationship.vue?vue&type=style&index=0&id=15cf22b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15cf22b5",
  null
  
)

export default component.exports